import { useState } from 'react';

export default function StayConnected() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    
    if (!email) return;
    
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d5t3omgt9f9av9ls7pmg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="w-full py-16 md:py-20 px-6 md:px-12 lg:px-24 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center" style={{ color: '#14B8A6', fontFamily: "'Inter', sans-serif" }}>
          Stay Connected
        </h2>
        
        <div className="bg-white rounded-lg p-8 md:p-10 shadow-sm border border-gray-100">
          <p className="text-lg font-light mb-8 text-center" style={{ color: '#374151', fontFamily: "'Inter', sans-serif", lineHeight: '1.8' }}>
            If you would like occasional insights on partnerships collaboration and aligned growth you are welcome to stay in touch.
          </p>
          
          <p className="text-lg font-light mb-8 text-center italic" style={{ color: '#6B7280', fontFamily: "'Inter', sans-serif", lineHeight: '1.8' }}>
            No spam. No pushing. Just thoughtful notes when there is something worth sharing.
          </p>
          
          <form onSubmit={handleSubmit} className="max-w-md mx-auto" data-readdy-form id="stay-connected-form">
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                required
                className="flex-1 px-4 py-3 border border-gray-300 rounded-lg text-base focus:outline-none focus:ring-2 focus:border-transparent"
                style={{ fontFamily: "'Inter', sans-serif", focusRing: '2px solid #1E40AF' }}
              />
              <button
                type="submit"
                className="px-8 py-4 text-white rounded-lg text-lg font-medium hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap"
                style={{ backgroundColor: '#14B8A6', fontFamily: "'Inter', sans-serif" }}
              >
                Subscribe
              </button>
            </div>
            
            {submitStatus === 'success' && (
              <p className="mt-4 text-center text-green-600 font-light" style={{ fontFamily: "'Inter', sans-serif" }}>
                Thank you! You're all set.
              </p>
            )}
            
            {submitStatus === 'error' && (
              <p className="mt-4 text-center text-red-600 font-light" style={{ fontFamily: "'Inter', sans-serif" }}>
                Something went wrong. Please try again.
              </p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}
